/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getBrandSquareOnlineSiteMappings} from '../api'

 export const useQueryGetBrandSquareOnlineSiteMappings = createReactQueryHook('getBrandSquareOnlineSiteMappings', getBrandSquareOnlineSiteMappings)
